module.exports = __webpack_public_path__ + "static/media/400029_02.66447475.png";